// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"bf421a86","348":"843d6194","378":"a555dc2c","522":"3144d5e3","587":"6d8e42cf","621":"fb91bd6c","984":"813131be","992":"2f3dc9b0","996":"6c9699d6"}[chunkId] + ".chunk.js";
};